import * as React from "react";
import { IAliExpressPullingImage } from "~/graphql/queries/aliexpress/optionPendingModeration";
import styled from "~/styled";

export enum ImageState {
  DEFAULT,
  MAIN_PRODUCT_IMAGE,
  DELETE
}

interface IProps {
  index: number;
  image: IAliExpressPullingImage;
  state: ImageState;

  onSelect: (imageId: string) => any;
  onDiscard: (imageId: string, bulk?: boolean) => any;
}

interface IImageWrapperProps {
  state: ImageState;
}

const ImageWrapper = styled.div<IImageWrapperProps>`
  position: relative;
  border-radius: 3px;
  border: 1px solid #0002;
  height: 300px;
  width: 300px;

  ${props =>
    props.state === ImageState.DELETE &&
    `
    border: 10px solid tomato;
  `};

  ${props =>
    props.state === ImageState.MAIN_PRODUCT_IMAGE &&
    `
    border: 10px solid green;
  `};
`;

const HotkeyHint = styled.span`
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 6px 12px;
  border-top-left-radius: 3px;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-size: 14px;
  font-weight: bold;
`;

const Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
  object-position: center;
`;

export default class ProductImage extends React.Component<IProps> {
  public render() {
    const { image, state, index } = this.props;
    const selectKeys = "1234567890qwertyuiopasdfghjklzxcvbnm".split("");

    return (
      <ImageWrapper state={state}>
        {index < selectKeys.length && (
          <HotkeyHint>{selectKeys[index]}</HotkeyHint>
        )}
        <Image
          onClick={this.handleClick}
          onContextMenu={this.handleClick}
          src={image.imageUrl.replace("http:", "https:")}
        />
      </ImageWrapper>
    );
  }

  public handleClick = (event: React.MouseEvent<HTMLImageElement>): void => {
    event.preventDefault();

    const { image, onDiscard, onSelect } = this.props;

    event.button === 2
      ? onDiscard(image.id, event.shiftKey)
      : onSelect(image.id);
  };
}



// WEBPACK FOOTER //
// ./src/components/ProductImageModeration/ProductImage.tsx